/**
 * @generated SignedSource<<1c6da8128d69fb52bb348633bbb70732>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActiveRecords = "ACTIVE" | "BOTH" | "INACTIVE" | "%future added value";
export type LearnosityPracticeProblemsSessionsFilterInput = {
  isActive: ActiveRecords;
  sessionIds?: ReadonlyArray<any> | null | undefined;
  skillIds?: ReadonlyArray<string> | null | undefined;
  studentIds?: ReadonlyArray<string> | null | undefined;
};
export type DashboardPracticeProblemsActionsQuery$variables = {
  input: LearnosityPracticeProblemsSessionsFilterInput;
};
export type DashboardPracticeProblemsActionsQuery$data = {
  readonly learnosityPracticeProblemsSessions: ReadonlyArray<{
    readonly id: string;
    readonly skill: {
      readonly id: string;
    } | null | undefined;
  }>;
};
export type DashboardPracticeProblemsActionsQuery = {
  response: DashboardPracticeProblemsActionsQuery$data;
  variables: DashboardPracticeProblemsActionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "filter",
        "variableName": "input"
      }
    ],
    "concreteType": "LearnosityPracticeProblemsSessionNode",
    "kind": "LinkedField",
    "name": "learnosityPracticeProblemsSessions",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "SkillNode",
        "kind": "LinkedField",
        "name": "skill",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardPracticeProblemsActionsQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardPracticeProblemsActionsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "afd02374c1bdd2e325360a16073663b3",
    "id": null,
    "metadata": {},
    "name": "DashboardPracticeProblemsActionsQuery",
    "operationKind": "query",
    "text": "query DashboardPracticeProblemsActionsQuery(\n  $input: LearnosityPracticeProblemsSessionsFilterInput!\n) {\n  learnosityPracticeProblemsSessions(filter: $input) {\n    id\n    skill {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5d4e0b4ec5799dd2a585d2cee59a3d6a";

export default node;
